import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Button, Divider, Grid, Typography } from '@mui/material'
import React from 'react'
import useModals from 'src/Hooks/useModals'
import { AddressType, AddressesData } from 'src/Libs/shop/models/billling-and-shipping-address-modal.model'
import { makeStyles } from 'tss-react/mui'

interface ConfirmCheckoutBillingAddressProps {
  currentAddress: string | null
  allAddresses: AddressesData
  onAddressChange: (newAddress: string) => void
}

const useStyles = makeStyles()(theme => ({
  billingAddressContainer: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    minHeight: '240px',
  },
  normalText: {
    color: theme.palette.text.primary,
    borderColor: theme.palette.grey.grey03,
  },
}))

const MINIMUM_BILLING_ADDRESSES = 1
/*
 * This component shows billing address and give the user the option to change it.
 */
const ConfirmCheckoutBillingAddress: React.FC<ConfirmCheckoutBillingAddressProps> = ({ currentAddress, allAddresses, onAddressChange }) => {
  const { classes } = useStyles()
  const { t } = useCustomTranslation()
  const { openShopBillingAndShippingModal } = useModals()
  const fullAddress = allAddresses.billingAddresses.find(address => address.addressId === currentAddress)
  const hasMinimumBillingAddresses = allAddresses.billingAddresses.length > MINIMUM_BILLING_ADDRESSES
  const openBillingModal = (): void => {
    if (currentAddress) {
      openShopBillingAndShippingModal({
        addressType: AddressType.Billing,
        defaultAddress: currentAddress,
        addressList: allAddresses.billingAddresses,
        onConfirm: newAddress => {
          onAddressChange(newAddress)
        },
      })
    }
  }

  return (
    <Grid item xs={12} md={6} className={classes.billingAddressContainer}>
      <Typography variant="h2" sx={{ fontWeight: 400 }} className={classes.normalText}>
        {t('shop.confirm-checkout.billing-address')}
      </Typography>
      <Divider className={classes.normalText} variant="fullWidth" />
      <Typography
        className={classes.normalText}
        sx={{
          marginTop: '24px',
          minHeight: '100px',
          marginBottom: '24px',
          lineHeight: '24px',
          whiteSpace: 'pre-line',
        }}
      >
        {fullAddress && fullAddress.companyName !== null && `${fullAddress.companyName}, \n`}
        {currentAddress && currentAddress.replace(',', ',\n')}
      </Typography>
      {hasMinimumBillingAddresses && (
        <Button
          className={classes.normalText}
          size="large"
          variant="outlined"
          color="inherit"
          sx={{ padding: '20px 32px' }}
          onClick={() => {
            openBillingModal()
          }}
        >
          {t('shop.confirm-checkout.change-billing-address')}
        </Button>
      )}
    </Grid>
  )
}

export default ConfirmCheckoutBillingAddress
